const storageKey = {
  MAIN_TAB_OPTIONS: 'layout_main_tab_options',
  TEMPLATE_GRID_CONFIG: 'template_grid_config'
}

export default storageKey
